export interface FlatTransactionsResponse {
  c: Record<string, string>;
  d: any[][];
  n: number;
  total: number;
}

export interface TransferPlanTransactionItem {
  _id: string;
  paymentId?: string;
  status: string;
  province?: string;
  kabkot?: string;
  wimaxIncome?: number;
  orpusIncome?: number;
  ordaIncome?: number;
  orlokIncome?: number;
  batchName?: string;
  user?: {
    _id: string;
    callsign?: string;
    nama_lengkap?: string;
    email?: string;
  };
  paymentGatewayData?: any;
  createdAt: string;
  updatedAt: string;
}

export interface TransferPlanTransactionsResponse {
  transactions: TransferPlanTransactionItem[];
  total: number;
}

function parseDate(d: string | null): string {
  if (!d) return "";
  return d;
}

export function parseFlatTransactions(
  flat: FlatTransactionsResponse
): TransferPlanTransactionsResponse {
  const transactions: TransferPlanTransactionItem[] = flat.d.map((row) => {
    const user =
      row[10] || row[11] || row[12] || row[13]
        ? {
            _id: row[10] ?? "",
            callsign: row[11] ?? undefined,
            nama_lengkap: row[12] ?? undefined,
            email: row[13] ?? undefined,
          }
        : undefined;

    return {
      _id: row[0] ?? "",
      paymentId: row[1] ?? undefined,
      status: row[2] ?? "",
      province: row[3] ?? undefined,
      kabkot: row[4] ?? undefined,
      wimaxIncome: row[5] ?? undefined,
      orpusIncome: row[6] ?? undefined,
      ordaIncome: row[7] ?? undefined,
      orlokIncome: row[8] ?? undefined,
      batchName: row[9] ?? undefined,
      user,
      paymentGatewayData: row[14] ?? undefined,
      createdAt: parseDate(row[15]),
      updatedAt: parseDate(row[16]),
    };
  });

  return { transactions, total: flat.total };
}
